module.exports = "data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHdpZHRoPSIxMjAwIiBoZWlnaHQ9IjYwMCI+PHBhdGggZmlsbD0iI0YyQTgwMCIgZD0iTTAgMGgxMjAwdjYwMEgweiIvPjxwYXRoIGZpbGw9IiMwMDMzQTAiIGQ9Ik0wIDBoMTIwMHY0MDBIMHoiLz48cGF0aCBmaWxsPSIjRDkwMDEyIiBkPSJNMCAwaDEyMDB2MjAwSDB6Ii8+PC9zdmc+"


//////////////////
// WEBPACK FOOTER
// ./src/assets/flags/arm.svg
// module id = 9AEl
// module chunks = 0